import React, { Component } from 'react';
import SurveyRect from './Shared/SurveyRect';
import FormatText from '../Utils/TextFormatter';
import MultiAns from './Shared/MultiAns';
import Timer from './Shared/Timer';
import shuffleAnswers from '../Utils/ShuffleAnswers';

export default class QuestionPage extends Component {

    state = {
        isCurrent: false,
        ansInx:-1,
        qKey:"",
        answers:[],
        answer:"",
        showAnswers: false,
    }

    componentDidUpdate(){
        const {isCurrent, answers} = this.props;
        if(this.state.isCurrent !== isCurrent){               
            this.setState({isCurrent:isCurrent});
        }

        //Updating answers preview during backoffice editing:
        if(this.state.answers !== answers){
            this.setState({answers:answers})
        }
    }

    componentDidMount(){
        const {readingTime, randomizeOrder} = this.props;
        // console.log("randomizeOrder? " + randomizeOrder);
        // console.log(`[+]\t readingTime = ${readingTime}`)
        if(readingTime === 0) {
            this.setState({showAnswers: true});
        }

        if( randomizeOrder ) { this.setState( { answers: shuffleAnswers( this.props.answers ) } ) }
        else { this.setState( { answers:this.props.answers } ); }
    }

    render(){
        const {style, qKey, preface, question, qTextSize, 
            readingTime, ansSpacing, ansTxtSize} = this.props;
        const {answers} = this.state;

        const padding = 28;
        let spacing = 60; 
        if(ansSpacing === 'spacious') spacing = 80;
        if(ansSpacing === 'narrow') spacing = 40;
        
        let questionText;
        if(qTextSize === `small`){ 
            questionText = <div className="smallQuestion">{FormatText(global.isMale,question)}</div>
        }
        if(qTextSize === `medium`){ 
            questionText = <h3>{FormatText(global.isMale,question)}</h3>
        }
        if(qTextSize === `large`){ 
            questionText = <h2>{FormatText(global.isMale,question)}</h2>
        }

		return <div style={style}>
            <SurveyRect {...this.props} H={440}>
                <div  style={{
                    position: "absolute",
                    right: padding,
                    left: padding,
                    top: padding,
                    bottom: 0,
                    overflow: "scrollY",
                    textAlign: "right",
                }}>
                    {(preface !== ``) && <div className="preface">{FormatText(global.isMale,preface)}</div>}
                    {questionText}
                    <div className="separation-bar"/>
                    <div style={{
                        opacity: this.state.showAnswers ? 1 : 0,
                        pointerEvents: this.state.showAnswers ? "":"none",
                        transition: "opacity 0.5s ease-out",
                    }}>
                        {                            
                            answers.map((_ans,i)=> {
                            
                            const ansTxt = FormatText(global.isMale,_ans.ans);
                                                        
                            return <MultiAns key={i} txt={ansTxt} 
                                H={40} W={"100%"} B={padding+(answers.length-i-1)*spacing}
                                isChoosen={this.state.answer===ansTxt && this.state.answer !== ""}
                                isOpenAns={_ans.isOpen}
                                ansTxtSize={ansTxtSize}
                                qKey={qKey}
                                onClick={(value)=>{
                                    const ans = _ans.isOpen ? value : _ans.key;
                                    this.setState({qKey:qKey, answer:ans, ansInx:i}, this.SetAnswer);
                                }}
                            />
                        })}
                    </div>
                </div>
                {readingTime > 0 && <Timer duration={readingTime} startCount={this.state.isCurrent} callBack={()=>{this.setState({showAnswers:true})}}/>}
            </SurveyRect>
        </div>
    }

    SetAnswer()
    {
        this.setState({showAnswers: true});
        global.setAnswer(this.state.qKey, this.state.answer, this.state.ansInx);
        const nextk = this.props.followingScreen === "by_ans" ? this.props.answers[this.state.ansInx].followingScreen : this.props.followingScreen;
        global.nextStage(nextk); 
    }
}


// WEBPACK FOOTER //
// ./src/Comp/QuestionPage.js